import ListingHeader from "../../../components/listingHeader/listingHeader";
import SBEditable from "../../../components/sbEditable/sbEditable";
import ArticleListingCard from "../../../components/articleListingCard/articleListingCard";

import styles from "./articleTypeFeaturedWidget.module.scss";
import { useStoryblokArticlesByTypeWidget } from "../../../hooks/useStoryblokArticlesByTypeWidget";
import StoryblokLink from "../../../components/link/StoryblokLink";

function ArticleTypeFeaturedWidget({ blok }) {
  const [articles, isLoading] = useStoryblokArticlesByTypeWidget(blok.article_type);

  if (!isLoading && articles.length === 0) {
    return null
  }

  return (
      <SBEditable blok={blok} withClass={`${styles.articleTypeFeaturedWidget} ${blok.margin_top ? styles.marginTopDefault : ""} ${blok.margin_bottom ? styles.marginBottomDefault : ""}`}>
      <ListingHeader>
        <h2>{blok.headline}</h2>
      </ListingHeader>
      <ul className={styles.list}>
        {isLoading ? <div className="loader centered" /> : null}
        {articles.slice(0, 5).map((a,idx) => (
          <li key={a.uuid}>
            <ArticleListingCard
              key={a.uuid}
              layout={
                idx < 3 ? "featured_article_type" : "noImage_article_type"
              }
              slug={a.slug}
              thumbnail={a.content.thumbnail}
              authors={a.content.authors}
              title={a.content.headline}
              summary={a.content.lead}
              date={a.content.article_date}
              article_category={a.content.category}
              article_type={a.content.article_type}
              comment_count={5}
              enable_comments={a.content.has_comments}
              enable_social_sharing={a.content.has_social_sharing}
              use_legacy_thumbnail_background={
                a.content.legacy_thumbnail_background
              }
            />
          </li>
        ))}
      </ul>
      {blok.show_button ? (
          <div className={styles.cta}>
            <StoryblokLink linkObject={blok.button_link} className="btn-scooter-outline mobile-fixed-width">
              {blok.button_text}
            </StoryblokLink>
          </div>
      ) : null}
    </SBEditable>
  );
}

export default ArticleTypeFeaturedWidget;
